<style>

.notification{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(255,255,255,1);
  color: black;
  min-height: 42px;
  z-index: 1000;
  padding: 10px;
  display: grid;
  grid-template-columns: auto 32px;
}
.text{
  grid-column: 1;
}
.close{
  grid-column: 2;
  text-align: right;
}
</style>

{#if show == true}

<div class="notification">
  <div class="text">
    You met 3 people this week and gone to 4 events.<br>
    <br>
    You'll only get these notifications once a week.
  </div>
  <div class="close" on:click="{ () => {show = false} }"> <i class="icon-cancel"></i> </div>
</div>

{/if}

<script>

export let show = false;



</script>